import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { profileDepartmentApi, roleApi } from '../../../../services/apis';
import { returnFlightDate } from '../../../../utils/utility/booking';
import { Modal, Confirmation, Tooltip } from '../../../../component';
import './employeeShowDetail.scss';

const INITIAL_DATA = {
  roles: [],
  basicInfo: {
    day: '',
    month: '',
    year: '',
    gender: '',
    birthDate: '',
    nationalCode: '',
    identityNo: '',
    passportNo: '',
    mobile: '',
    mobileWithoutCode: '',
    countryAbr: 'ir',
    avatar: '',
  },
  userName: '',
  password: '',
  firstName: '',
  lastName: '',
  email: '',
  departmentId: 0,
};

class EmployeeShowDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: structuredClone(INITIAL_DATA),
      roleList: [],
      departmentList: [],
      alertBody: '',
      alertType: '',
      isShowAlert: false,
    };
  }

  async componentDidMount() {
    try {
      const {
        payload: { data },
      } = await roleApi.getAll();
      this.setState({ roleList: data });
    } catch (error) {
      console.log(error);
    }
    try {
      const { profileId } = this.props;
      const {
        payload: { data },
      } = await profileDepartmentApi.getAllByProfileId({
        profileId,
        itemPerPage: 20,
        pageNumber: 1,
      });
      this.setState({
        departmentList: data.rows,
      });
    } catch (error) {
      console.log(error);
    }
  }

  showGender = (isMale) => {
    switch (isMale) {
      case 1:
        return <FormattedMessage id="booking.male" />;
      case 2:
        return <FormattedMessage id="booking.female" />;
      default:
        return '--';
    }
  };

  RenderItem = ({ label, value, customClass = '', ...rest }) => {
    const {
      language: { name: Lname, direction },
    } = this.props;

    if (Array.isArray(value)) {
      value = value.map(
        (item, indx) =>
          `${item.name[Lname]}${indx < value.length - 1 ? ' - ' : ''}`,
      );
    }
    return (
      <div
        className={`d-flex flex-column text-start text-muted pb-sm-4 pb-3 mb-2`}
      >
        <label className="w-100 text-start font-normal text-dark px-3">
          <FormattedMessage id={`profile.${label}`} />
        </label>
        <div
          className={`w-100 d-flex flex-row ${
            label === 'mobile' && direction === 'rtl'
              ? 'justify-content-end'
              : 'justify-content-start'
          } align-items-center bg-third-light default-border-radius-small font-normal min-height-55px px-sm-3 px-3 ${customClass}`}
          style={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'rgb(189, 198, 243)',
          }}
        >
          {value ? (
            <Tooltip
              position={'top'}
              content={value || ''}
              direction={direction}
              backgroundColor="warning"
              textColor="dark"
              customClassName={'w-100 text-start'}
            >
              <span className="w-100 d-flex text-nowrap text-truncate">
                <span className="w-100 text-truncate">{value}</span>
              </span>
            </Tooltip>
          ) : (
            '---'
          )}
        </div>
      </div>
    );
  };

  render() {
    const { isShowAlert, alertType, alertBody } = this.state,
      {
        intl,
        employeeData: { createdAt },
        language: { name = 'en' },
      } = this.props;
    const {
        employeeData: {
          firstName,
          lastName,
          email,
          departmentName,
          roleName,
          basicInfo: {
            gender = '',
            mobile = '',
            nationalCode = '',
            year = '',
            month = '',
            day = '',
            passportNo = '',
            identityNo = '',
          },
        },
        language: { name: Lname },
      } = this.props,
      { departmentList, roleList } = this.state,
      { RenderItem } = this,
      {
        basicInfo: { avatar },
      } = this.props.employeeData;
    return (
      <>
        {isShowAlert && (
          <Confirmation
            isConfirmation={false}
            onReject={() => this.setState({ isShowAlert: false })}
            show={isShowAlert}
            type={alertType}
            closeTime={2000}
            body={intl.formatMessage({ id: alertBody })}
            defaultDescription={intl.formatMessage({ id: alertBody })}
            title={intl.formatMessage({ id: alertBody })}
          />
        )}
        <Modal
          id="showDetailModal"
          modalSize={'my-5 modal-lg'}
          modalWidth="col-12 col-xl-10 col-sm-11 mb-5"
          detail={
            <div className="">
              <FormattedMessage id="profile.employeeRegistrationDate" />
              <span className="px-1">:</span>
              <span>{returnFlightDate(createdAt, name, false)}</span>
            </div>
          }
          isOpen={this.props?.isOpen}
          onClose={() => {
            this.props.onClose();
          }}
        >
          <div className=" employee-show-detail-container">
            <div className="employee-detail-modal-body pt-3 pb-4 text-center">
              <div className="col-12 px-0 d-flex flex-xs-row flex-column mb-sm-4 mb-2 pb-1">
                <div className="flex-grow-1 invite-form-container col-md-6 col-xs-7 col-12 px-md-3 px-0 d-flex flex-row justify-content-start align-items-center">
                  <div
                    className="h-100 d-flex flex-row justify-content-start pt-md-2 pt-0"
                    style={{ width: '20rem' }}
                  >
                    <img
                      className="img-fluid default-border-radius-small img-setup"
                      alt="info-employee"
                      src={require('../../../../content/images/elements/show-details.png')}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-xs-5 col-12 px-md-3 px-xs-1 px-3 pt-xs-0 pt-3 d-flex flex-column justify-content-start align-items-start">
                  <span className="text-primary pt-md-4 pt-sm-3 pt-2 font-sm-xxlarge font-normal text-nowrap">
                    <FormattedMessage id="commissionmanagement.showdetail" />
                  </span>
                  <div className="col-md-10 w-100 text-third text-start pt-md-4 pt-sm-3 pt-1 px-0">
                    <p className="font-lg-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                      <FormattedMessage id="commissionmanagement.textDetails" />
                    </p>
                  </div>
                </div>
              </div>
              <div className="employee-detail-data d-flex justify-content-center flex-row flex-wrap">
                <div
                  className={`px-0 col-12 d-flex flex-row flex-wrap mt-xs-3 mt-0`}
                >
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      label={'firstname'}
                      name={'firstName'}
                      value={firstName}
                      type="Input"
                      isNested={false}
                      outSideLabel={true}
                      outSideLabelPosition="top"
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      label={'lastname'}
                      name={'lastName'}
                      value={lastName}
                      type="Input"
                      isNested={false}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      name={'email'}
                      label={'email'}
                      value={email}
                      type="Input"
                      isNested={false}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      label={'password'}
                      name={'passWord'}
                      value={'******'}
                      type="Input"
                      isNested={false}
                    />
                  </div>
                  <div className={`col-sm-6 col-12`}>
                    <RenderItem
                      label={'gender'}
                      name={'gender'}
                      value={this.showGender(gender)}
                      type="Dropdown"
                      isNested={true}
                      options={{
                        data: [
                          { value: 1, name: { en: 'Male', fa: 'آقا' } },
                          { value: 2, name: { en: 'Female', fa: 'خانم' } },
                        ],
                        label: 'name',
                        value: 'value',
                        isMultiLanguage: true,
                      }}
                    />
                  </div>
                  <div className={`col-sm-6 col-12`}>
                    <RenderItem
                      label={'birthdate'}
                      name={'birthDate'}
                      value={
                        year &&
                        month &&
                        day &&
                        returnFlightDate(
                          `${year}-${month}-${day}`,
                          Lname,
                          false,
                        )
                      }
                      type="DatePicker"
                      isNested={true}
                    />
                  </div>
                  <div className={`col-sm-6 col-12`}>
                    <RenderItem
                      name={'departmentId'}
                      label={'department'}
                      value={departmentName[name === 'fa' ? 'fa' : 'en']}
                      type="Dropdown"
                      isNested={true}
                      options={{
                        data: departmentList,
                        label: 'name',
                        isMultiLanguage: true,
                        value: 'id',
                      }}
                    />
                  </div>
                  <div className={`col-sm-6 col-12`}>
                    <RenderItem
                      label={'employeeRole'}
                      name={'roles'}
                      value={roleName}
                      isNested={true}
                      type="Dropdown"
                      options={{
                        data: roleList,
                        label: 'name',
                        value: 'id',
                        isMultiLanguage: true,
                      }}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      label={'mobile'}
                      name={'mobile'}
                      value={mobile}
                      customClass="d-flex mobile-container phone-input"
                      type="Input"
                      isNested={true}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      label={'passportNumber'}
                      name={'passportNo'}
                      value={passportNo}
                      type="Input"
                      isNested={true}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      label={'identityno'}
                      name={'identityNo'}
                      value={identityNo}
                      type="Input"
                      isNested={true}
                    />
                  </div>
                  <div className="col-sm-6 col-12">
                    <RenderItem
                      label={'nationalcode'}
                      name={'nationalCode'}
                      value={nationalCode}
                      type="Input"
                      isNested={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(injectIntl(EmployeeShowDetail));
